module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/image7-adc631f741b4ce1bac94d8ea28a8b2e3.png";